import { Box } from "@mui/material";

import { useTemplateContext } from "./TemplateContext";

export const TemplateEditorView = ({}) => {
  const { state } = useTemplateContext();

  return (
    <div style={{ position: "relative" }} id="template-container">
      <Box
        sx={{
          "& center": {
            backgroundColor: "unset !important",
          },
          "& .main": {
            borderRadius: "30px",
            overflow: "hidden",
          },
        }}
        dangerouslySetInnerHTML={{ __html: state.template?.body ?? "" }}
      ></Box>
    </div>
  );
};
